import changelogData from './changelog.json';

export interface ChangelogEntry {
  version: string;
  date: string;
  features: string[];
  improvements: string[];
  fixes: string[];
}

/**
 * Änderungshistorie. Datenquelle ist changelog.json (Single Source) — so kann
 * vite.config sie zur Build-Zeit ohne TS-Import (readFileSync) lesen und als
 * dist/changelog.json emittieren (für das „Was ist neu?"-Panel im Update-Banner).
 */
export const changelog: ChangelogEntry[] = changelogData as ChangelogEntry[];
